import { render, staticRenderFns } from "./LevelItems.vue?vue&type=template&id=2dcb0054&scoped=true&"
import script from "./LevelItems.vue?vue&type=script&lang=js&"
export * from "./LevelItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb0054",
  null
  
)

export default component.exports